import template from "./quote-section.html";

const QuoteSectionComponent = {
  bindings: {
    section: "<",
    quoteLanguageResource: "<",
    quote: "<",
    index: "<",
    isFirst: "<",
    isLast: "<",
    updatedRatesLastDate: "<",
    existCostWithDifferentCurrency: "&",
    areRatesUpdated: "&",
    updateRates: "&",
    onApplyCustomStyleToQuote: "&",
    onChange: "&",
    onMoveUp: "&",
    onMoveDown: "&",
    onAddSection: "&",
    onDeleteSection: "&",
  },
  template: template,
  controller: class QuoteSectionController {
    /* @ngInject */
    constructor(
      $rootScope,
      $scope,
      $filter,
      ModalsManager,
      QuoteSectionTemplate,
      Notification,
      TinyMceService,
      $timeout
    ) {
      this.$rootScope = $rootScope;
      this.$scope = $scope;
      this.$filter = $filter;
      this.ModalsManager = ModalsManager;
      this.QuoteSectionTemplate = QuoteSectionTemplate;
      this.NotificationService = Notification;
      this.TinyMceService = TinyMceService;
      this.$timeout = $timeout;
    }

    $onInit() {
      this.tinyMceOptions = this.TinyMceService.getConfig(this.quote);
      this.popoverChangeBackgroundOpened = false;
      this.popoverChangeStylesOpened = false;
      this.isNewSectionShown = false;
      this.player = null;
      this.playerVars = {
        autoplay: 1,
        autohide: 1,
        rel: 0,
        showinfo: 0,
        controls: 0,
        disablekb: 1,
        enablejsapi: 1,
        iv_load_policy: 3,
      };

      this.$scope.$watch(
        () => this.popoverChangeBackgroundOpened,
        () => {
          this.popoverChangeBackgroundOpened =
            !!this.popoverChangeBackgroundOpened;
        }
      );

      this.$scope.$watch(
        () => this.popoverChangeStylesOpened,
        () => {
          this.popoverChangeStylesOpened = !!this.popoverChangeStylesOpened;
        }
      );

      this.$scope.$watch(
        () => this.section.style.backgroundVideo,
        () => {
          if (
            !this.section.style.backgroundVideo ||
            !this.isYoutubeVideo() ||
            !this.player
          )
            return;
          if (!this.section.style.backgroundVideo.enabledSound)
            this.player.mute();
          else this.player.unMute();
        }
      );

      this.$scope.$on("youtube.player.ready", ($event, player) => {
        this.player = player;
        if (!this.section.style.backgroundVideo.enabledSound) player.mute();
      });

      this.$scope.$on("youtube.player.ended", ($event, player) => {
        player.playVideo();
      });
    }

    $onChanges(changesObj) {
      if (changesObj.section && this.section.sectionType === "pricingTable")
        this.pricingTablePreview = angular.copy(this.section.pricingTable);
    }

    isPricingTableSection() {
      return this.section.sectionType === "pricingTable";
    }

    visibleNewSection() {
      this.isNewSectionShown = !this.isNewSectionShown;
      if (this.isNewSectionShown) {
        this.$timeout(() => {
          $("body, html").animate(
            {
              scrollTop:
                $(`.quote-section-${this.index}`).next().offset().top - 70,
            },
            1000
          );
        }, 30);
      }
    }

    isYoutubeVideo() {
      if (!this.section.style.backgroundVideo) return false;
      return (
        this.section.style.backgroundVideo.url.includes("youtube.com") ||
        this.section.style.backgroundVideo.url.includes("youtu.be")
      );
    }

    async changeSectionSize() {
      if (this.section.style.size === "auto") this.section.style.size = "full";
      else this.section.style.size = "auto";
      await this.onChange({ section: this.section });
    }

    async editPricingTable() {
      const pricingTableUnchanged = angular.copy(this.section.pricingTable);
      if (
        !(await this.ModalsManager.openPricingTableModal({
          pricingTable: this.section.pricingTable,
          onChangePricingTable: () => {
            this.onChangePricingTable();
          },
          updatedRatesLastDate: this.updatedRatesLastDate,
          existCostWithDifferentCurrency: () =>
            this.existCostWithDifferentCurrency(),
          areRatesUpdated: () => this.areRatesUpdated(),
          updateRates: () => {
            this.updateRates();
          },
        }))
      ) {
        this.section.pricingTable = pricingTableUnchanged;
      }
    }

    getSizeLabel() {
      if (this.section.style.size === "auto")
        return this.$filter("trans")("quoteSection.fullScreen");
      else return this.$filter("trans")("quoteSection.autoSize");
    }

    getSizeIcon() {
      if (this.section.style.size === "auto") return "zmdi zmdi-fullscreen-alt";
      else return "zmdi zmdi-square-down";
    }

    getNewSectionTooltip() {
      if (this.isNewSectionShown)
        return this.$filter("trans")("quoteSection.cancel");
      else return this.$filter("trans")("quoteSection.newSection");
    }

    async saveSection() {
      const quoteSectionName =
        await this.ModalsManager.openQuoteSectionNameModal();
      if (!quoteSectionName) return;

      const quoteSectionTemplate = new this.QuoteSectionTemplate({
        organization: this.$rootScope.organization._id,
        sectionType: this.section.sectionType,
        name: quoteSectionName,
        style: angular.copy(this.section.style),
        pricingTable: angular.copy(this.section.pricingTable),
        currency: this.isPricingTableSection()
          ? this.section.pricingTable.currency
          : undefined,
        content: this.section.content,
        contentBelowPricing: this.section.contentBelowPricing,
        brandCenterSync: this.section.brandCenterSync,
      });

      if (!(await quoteSectionTemplate.create())) return;

      this.NotificationService.success({
        title: this.$filter("trans")("notificationService.title.success"),
        message: this.$filter("trans")(
          "notificationService.message.sectionSaved"
        ),
      });
    }

    onChangePricingTable() {
      this.pricingTablePreview = angular.copy(this.section.pricingTable);
      this.onChange({ section: this.section });
    }

    onAddSectionHandler(type, quoteSection) {
      this.visibleNewSection();
      this.onAddSection({ type: type, quoteSection: quoteSection });
    }

    onCancelAddSection() {
      this.visibleNewSection();
    }
  },
};

export default QuoteSectionComponent;
